import api from '../../plugins/api';

const createModel = (params) => {
  return api.post('/api/crm/cars/createModel', params);
};

export default createModel;
